import { type FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { TrialContactsLimitAlertStore } from 'entities/Subscription/ui/TrialContactsLimitAlert/store/trialContactsLimitAlertStore'
import { useEntitiesContext } from 'entities/EntitiesExport'

type ITrialAlertContactsProps = {
  totalAmount: number
}

export const TrialContactsLimitAlert: FC<ITrialAlertContactsProps> = observer(({ totalAmount }) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new TrialContactsLimitAlertStore(entities))

  useEffect(() => {
    store.init()
  }, [])

  useEffect(() => {
    store.setTotalAmount(totalAmount)
  }, [totalAmount])

  if (store.hide) return null

  return <Alert {...store.configAlert} />
})
